import { render, staticRenderFns } from "./TowerSettings.vue?vue&type=template&id=ecb87fd6"
import script from "./TowerSettings.vue?vue&type=script&lang=js"
export * from "./TowerSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports